export default __webpack_public_path__ + "static/media/8 1.2f276550.svg";